import { StyleSheet } from 'aphrodite';
import { darkGrayFontColor, header } from '../../../styles/colors';

export const styleSheet = StyleSheet.create({
	loading: {
		marginTop: 30,
	},
	rightAccessory: {
		color: header,
		fontSize: 12,
		letterSpacing: 0,
	},
	text: {
		color: darkGrayFontColor,
		fontSize: 14,
		letterSpacing: 0,
		lineHeight: '20px',
	},
});
